export default __webpack_public_path__ + "static/media/arrow.11624b26.svg";